import Vue from 'vue'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import router from './router'
import firebase from 'firebase' //★が認証用で追加

Vue.config.productionTip = false

//★
const config = {
  apiKey: "AIzaSyB_O4X2TEcddKIMP8u81wSJ-MMOrCuIIxA",
  authDomain: "generalnotificationsyste-f58bb.firebaseapp.com",
  databaseURL: "https://generalnotificationsyste-f58bb.firebaseio.com",
  projectId: "generalnotificationsyste-f58bb",
  storageBucket: "generalnotificationsyste-f58bb.appspot.com",
  messagingSenderId: "409694582895",
  appId: "1:409694582895:web:3d4cb4390c8c56aebeb59a",
  measurementId: "G-5BLGZCKWQB"
}
//★
firebase.initializeApp(config);


new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
